import React, { useState, useEffect } from "react";
import {
  Button,
  Table
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { findInArray, searchFilterFunction } from "../Utility/function";
import { colors } from "../configs";
import { BrowserRouter as Router, Routes, Route, Link, Navigate, Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Modal_Loading } from "../modal";
import { fetchNormalShop } from "../redux/shopSlice";
import { addShopId, logout } from "../redux/authSlice";
import { db } from "../db/firestore";
import { OneButton, SearchControl } from "../components";

const { white } = colors;

function ShopListScreen() {
  const navigate = useNavigate();
    const dispatch = useDispatch();
    const { profile } = useSelector((state)=> state.profile);
    const { port, id:profileId } = profile
    const [loading, setLoading] = useState(false);
    const [admin, setAdmin] = useState([]);
    const [search, setSearch] = useState('');
    const [display, setDisplay] = useState([]);


    useEffect(()=>{
      let arr = port
      if(search){
        arr = searchFilterFunction(port,search,'shopName')
      }
      setDisplay(arr)
    },[port,search])


    useEffect(()=>{
      db.collection('admin').doc('admin').get().then((doc)=>{
        if(doc.exists){
          setAdmin(doc.data().value)
        }
      })
    },[]);

    async function backToShop(data){
      setLoading(true)
      let shopData = {}
      try {
          const qsnapshot = await db.collection('shop').where('shopId','==',data.shopId).get();
          qsnapshot.docs.forEach((doc)=>{
            shopData = {...doc.data(), id:doc.id}
          })
          const { humanResource = [] } = shopData;
          if(humanResource.some(a=>a.id===profileId && (a.rights?.includes('107') || a.owner || a?.position?.includes('001') ))){
            // if(humanResource.some(a=>a.id===profileId && (a.rights?.includes('107') || a.owner ))){
            navigate('/master')
          } else {
            if(admin.includes(profileId)){
              setLoading(false)
              navigate('/master')
            } else {
              alert('คุณไม่มีสิทธิ์เข้าถึงร้านค้านี้ กรุณาเพิ่มสิทธิ์ที่แอป หัวข้อจัดการพนักงาน  ข้อ 7. รายงาน')
            }
          }
          dispatch(fetchNormalShop(shopData));
          dispatch(addShopId({
            currentShopId:data.id,
            franchiseDisplay:false
          }));
      } catch (error) {
        alert(error)
      } finally {
        setLoading(false)
      }
      
    };

      function exit(){
        dispatch(logout()).then(()=>{
          navigate('/')
        })
      }
    
  return (
    <div style={styles.container} >
        <Modal_Loading show={loading} />
        <div style={{position:'sticky', top:0, backgroundColor:white, paddingBottom:10 }} >
          <div style={styles.container2} >
              <h1>เลือกร้านค้า</h1>
          </div>
          <Button onClick={exit} variant="lignt" style={{position:'absolute', top:0, right:10, fontSize:25 }} >
              <i class="bi bi-box-arrow-right"></i>
          </Button>
          <div style={{marginLeft:'1rem',marginRight:'1rem'}} >
            <SearchControl {...{ placeholder:'ค้นหาด้วยชื่อร้าน',  search, setSearch }} />
          </div>
        </div>
        
        <React.Fragment>
              <br/>
              <Table striped bordered hover responsive  variant="light" style={{marginLeft:'1rem'}}  >
                  <thead  >
                    <tr>
                        <th style={styles.container3} >No.</th>
                        <th style={styles.container3} >โลโก้</th>
                        <th style={styles.container4} >ร้านค้า</th>
                        <th style={styles.container4} >เข้าสู่ระบบ</th>
                    </tr>
                  </thead>
                  <tbody  >
                  {display?.map((item, index) => {
                      const { id, shopName, imageUrl } = item;
                      let imageId = findInArray(imageUrl||[],'type','logo')?.value || ''
                      return <tr  key={id} >
                                  <td style={styles.container5} >{index+1}.</td>
                                  <td>
                                    {imageId
                                        ?<img style={styles.img} src={imageId} alt="My Image" />
                                        :<img style={styles.img} src={'/logo512.png'} alt="My Image" />
                                    }
                                  </td>
                                  <td >{shopName}</td>
                                  <td style={styles.container5} >
                                    <OneButton {...{ text:'เข้าสู่ระบบ', variant:'success', submit:()=>{backToShop(item)} }} />
                                  </td>
                              </tr>
                  })}
                  </tbody>
              </Table>
        </React.Fragment>
    </div>
  );
};

const styles = {
    container : {
      backgroundColor:white,height:'100vh'
    },
    container2 : {
      backgroundColor:white,display:'flex',justifyContent:'center'
    },
    container3 : {
      width:'10%', textAlign:'center'
    },
    container4 : {
      width:'25%', textAlign:'center'
    },
    container5 : {
      textAlign:'center'
    },
    img : {
      width:80,height:80,borderRadius:20
    }
  
}

export default ShopListScreen;
